import moment from "moment";
import { Badge } from "primereact/badge";
import TextWrap from "../custom/TextWrap.js";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FcShop } from "react-icons/fc";

export const columns = [
  {
    field: "order_id",
    header: "#",
    accessor: (row, handleCellClick) => (
      <>
        <div
          onClick={() => handleCellClick(row, "order_id")}
          className=""
        >
          <p>{row?.order_id}</p>
          <p className="w-[6rem]">
            {moment(row?.createdAt).utc().format("DD MMM YYYY hh:mma")}
          </p>
        </div>
      </>
    ),
  },
  {
    field: "created_by",
    header: "Vendor",
    accessor: (row, handleCellClick) => (
      <div className="w-fit">
        <div className="overflow-hidden flex flex-col justify-center items-center">
          {row?.created_by?.profile_image ? (
            <LazyLoadImage
              src={row?.created_by?.profile_image}
              alt="img"
              loading="lazy"
              effect="blur"
              wrapperProps={{
                style: { transitionDelay: "1s" },
              }}
              className="rounded-full w-20 h-20"
            />
          ) : (
            <div className="rounded-full w-20 h-20 bg-[#d2d2d2] flex justify-center items-center">
              <FcShop className="text-[3rem]  text-[#02aabd93]" />
            </div>
          )}
          <p className="mt-2">{row?.created_by?.first_name}</p>
        </div>
      </div>
    ),
  },
  {
    field: "promo_code",
    header: "Promocode",
    accessor: (row) => (
      <>
        <div className="">
          <p>{row?.promo_code}</p>
        </div>
      </>
    ),
  },
  {
    field: "description",
    header: "Description",
    accessor: (row) => (
      <>
        <div className="">{TextWrap(row?.description, 30)}</div>
      </>
    ),
  },

  {
    field: "promo_for",
    header: "Promo code for",
    accessor: (row) => (
      <div className="w-fit">
        <p className="w-full text-nowrap text-center">{row?.promo_for}</p>
      </div>
    ),
  },
  {
    field: "start_date",
    header: "Start Date",
    accessor: (row) => (
      <div className="w-fit">
        <p className="w-full text-nowrap text-center">{row?.start_date}</p>
      </div>
    ),
  },

  {
    field: "end_date",
    header: "End date",
    accessor: (row) => <p>{row?.end_date}</p>,
  },
  {
    field: "repeat",
    header: "Repeat",
    accessor: (row) => <p>{row?.repeat}</p>,
  },
  {
    field: "required_uses",
    header: "Usage",
    accessor: (row) => <p>{row?.required_uses}</p>,
  },
  {
    field: "apply_offer_after_orders",
    header: "Post Order",
    accessor: (row) => <p>{row?.apply_offer_after_orders}</p>,
  },
  {
    field: "min_order_amount",
    header: "Min order",
    accessor: (row) => <p>{row?.required_uses}</p>,
  },
  {
    field: "min_item_on_cart",
    header: "Min item ",
    accessor: (row) => <p>{row?.required_uses}</p>,
  },
  {
    field: "max_discount_amount",
    header: "Max Disc",
    accessor: (row) => <p>{row?.max_discount_amount?.$numberDecimal}</p>,
  },
  {
    field: "status",
    header: "Status",
    accessor: (row) => (
      <>
        {row?.status && (
          <Badge
            className="w-[6rem]"
            severity={row?.status === "Unapproved" ? "danger" : "success"}
            value={row?.status}
          />
        )}
      </>
    ),
  },
 
  // {
  //   field: "created_by",
  //   header: "Created by",
  //   accessor: (row) => <p>{row?.created_by?.first_name}</p>,
  // },
];

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const filters = [
  {
    filterType: "Promo Code for",
    inputName: "promo_for",
    options: [
      {
        name: "Store",
        code: "Store",
      },
      {
        name: "Product",
        code: "Product",
      },
      {
        name: "Category",
        code: "Category",
      },
      {
        name: "Sub Category",
        code: "Sub Category",
      },
    ],
  },
  {
    filterType: "Frequency",
    inputName: "repeat",
    options: [
      {
        name: "No",
        code: "No",
      },
      {
        name: "Daily",
        code: "Daily",
      },
      {
        name: "Weekly",
        code: "Weekly",
      },
      {
        name: "Monthly",
        code: "Monthly",
      },
      {
        name: "Annually",
        code: "Annually",
      },
    ],
  },
];

export const canlenderFilter = {
  filterType: "Start Date",
  inputName: "start_date",
  maxDate: new Date(),
};
